<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="12" md="12">
        <p class="text-h6">Datos de metodo de pago</p>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-text-field v-mask="'AAAA'" label="CLAVE" :prefix="Dnrele && !edit ? 'CB_' : ''" v-model="Id" outlined dense
          required :rules="rulesId"></v-text-field>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-text-field label="Nombre" v-model="Nombre" :rules="rulesNombre" outlined dense required></v-text-field>
      </v-col>
      <v-col class="mt-n5" cols="12" md="12">
        <v-autocomplete label="Moneda" v-model="Moneda" :items="monedas" item-value="id" item-text="Nombre" outlined
          dense required></v-autocomplete>
      </v-col>

        <v-col class="mt-n5" cols="12" sm="4">
          <v-switch color="green" label="Activo" v-model="Activo" dense></v-switch>
        </v-col>
        <v-col class="mt-n5" cols="12" sm="4">
          <v-switch color="red darken-2" label="Ocultar en PDV" v-model="opdv" dense></v-switch>
        </v-col>
        <v-col class="mt-n5" cols="12" sm="4">
          <v-switch color="red darken-2" label="Ocultar en Comandero" v-model="ocmd" dense></v-switch>
        </v-col>
    </v-row>
    <div class="text-right">
      <v-btn large @click="$emit('toggle', false)">Cancelar</v-btn>
      <v-btn @click="checkForm()" style="margin-left: 6px" color="success" large>Guardar</v-btn>
    </div>
  </v-form>
</template>

<style scoped></style>

<script>
import { mapGetters } from "vuex";
import { V } from "../../../helpers/ValidationRules";
export default {
  name: "MetodosPagoForm",
  components: {},
  props: ["edit", "dataEdit"],
  data() {
    return {
      Id: "",
      Nombre: "",
      Moneda: "All",
      Activo: true,
      Prtgdo: false,
      Dnrele: false,
      opdv: false,
      ocmd: false,
      rulesId: [
        V.required('Campo requerido'),
        V.exactLength(4, 'Debe tener 4 caracteres'),
        V.alphanumeric('Solo caracteres alfanuméricos'),
      ],
      rulesNombre: [
        V.required('El nombre es obligatorio'),
        V.minLength(2, 'El nombre debe tener al menos 2 caracteres'),
      ],
    };
  },
  computed: {
    ...mapGetters(["getPDVPagosTipos", "getPDVMonedasLista"]),
    monedas() {
      let monedas = [{ id: "All", Nombre: "Todas" }];
      this.getPDVMonedasLista.forEach((moneda) => {
        monedas.push(moneda);
      });
      return monedas;
    },
  },
  watch: {
    Id(val) {
      if (val) {
        this.Id = val.toUpperCase();
      }
    },
  },
  methods: {
    checkForm() {
      if (this.$refs.form.validate()) {
        let doAction = "CREATE";
        if (this.edit) {
          doAction = "EDIT";
        }
        this.send(doAction);
      }
    },
    send(action) {
      const dataSave = this.$data;

      this.$emit("successData", dataSave, action);
    },
  },
  mounted() {
    if (this.edit) {
      this.Id = this.dataEdit.id;
      this.Nombre = this.dataEdit.Nombre;
      this.Moneda = this.dataEdit.Moneda;
      this.Activo = this.dataEdit.Activo;
      this.Prtgdo = this.dataEdit.Prtgdo;
      this.opdv = !!this.dataEdit.opdv;
      this.ocmd = !!this.dataEdit.ocmd;
      //this.Dnrele = this.dataEdit.Dnrele;
    }
  },
};
</script>
